import React, { useState, useEffect } from 'react'
import RulesList from './RulesList';
import AddRules from './AddRules';
import MainView from './FDVG/Main'
import { loadRules } from '../../../../reducers/JsonRuleEditor/RulesActions';
import { useDispatch } from 'react-redux';
import BackLogo from '../../../../images/rewampimages/Chevron.png'
export default function Main({ pageViewHandler }) {
    const [view, setView] = useState("list")
    const [viewdata, setviewdata] = useState({})

    const dispatch = useDispatch();

    useEffect(() => {

        dispatch(loadRules());
    }, [dispatch]);

    const handleView = (type) => {
        setView(type)
    }

    const handleViewData = (data) => {
        setviewdata(data)
    }

    return (
        <>
            {
                view === "list" ?
                    <div className='' style={{ marginTop: '10px', marginBottom: window.innerWidth > 1800 ? '100px' : '10px', display: 'inline-flex', alignItems: 'center', marginLeft: '15px' }} onClick={(e) => pageViewHandler(e, 'landingPage')}>
                        <img src={BackLogo} alt="" width={'35%'} style={{ marginRight: '10px', cursor: 'pointer' }} />
                        <h5 style={{ cursor: 'pointer' }}>Back</h5>
                    </div>
                    : ''}

            <div className='JsonRulesEditor-css' style={{marginTop:'20px'}}>
                {
                    view === "list" ?
                        <RulesList handleView={handleView} handleViewData={handleViewData} />
                        : ''}
                {
                    view === "add" ?
                        <AddRules handleView={handleView} />
                        : ''}
                {
                    view === "view" ?
                        <MainView viewdata={viewdata} handleView={handleView}/>
                        : ''}
            </div>

        </>
    )
}
